import globalEventbus from './globalEventbus'

window.onMessageFromXhwxApp = function onMessageFromXhwxApp(...data) {
  globalEventbus.$emit('MSG_FROM_XHWX_APP', data)
  
}